export default "__VITE_ASSET__Dnjwm6fz__"